import React, { useEffect } from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./CookieConsent.scss";

// Definizione dei cookie utilizzati dal sito
// Per aggiungere nuovi cookie, aggiungi un oggetto all'array seguente
export const COOKIE_LIST = [
  // COOKIE NECESSARI (sempre attivi)
  {
    name: "theme-preference",
    category: "necessary",
    description: "Memorizza la preferenza del tema (chiaro/scuro)",
    duration: "1 anno",
    type: "LocalStorage",
  },
  {
    name: "cookie-consent",
    category: "necessary",
    description: "Memorizza le preferenze sui cookie dell'utente",
    duration: "1 anno",
    type: "LocalStorage",
  },
  {
    name: "session-id",
    category: "necessary",
    description: "Identificatore di sessione per la navigazione",
    duration: "Sessione",
    type: "Cookie",
  },

  // COOKIE ANALITICI (opzionali - richiedono consenso)
  // Esempio: quando aggiungi Google Analytics, decommenta e modifica:
  // {
  //   name: '_ga',
  //   category: 'analytics',
  //   description: 'Cookie di Google Analytics per identificare utenti unici',
  //   duration: '2 anni',
  //   type: 'Cookie'
  // },
  // {
  //   name: '_gid',
  //   category: 'analytics',
  //   description: 'Cookie di Google Analytics per distinguere gli utenti',
  //   duration: '24 ore',
  //   type: 'Cookie'
  // },

  // COOKIE MARKETING (opzionali - richiedono consenso)
  // Esempio:
  // {
  //   name: '_fbp',
  //   category: 'marketing',
  //   description: 'Cookie del pixel di Facebook per tracciare le conversioni',
  //   duration: '3 mesi',
  //   type: 'Cookie'
  // }
];

export const CookieConsent: React.FC = () => {
  useEffect(() => {
    console.log("🍪 CookieConsent: Inizializzazione...");

    // Importazione dinamica
    import("vanilla-cookieconsent")
      .then((module) => {
        // vanilla-cookieconsent esporta direttamente, non come default
        const cc = module;
        console.log("🍪 CookieConsent: Modulo caricato", cc);

        // Suppress semver warnings from vanilla-cookieconsent
        const originalError = console.error;
        console.error = (...args: any[]) => {
          const message = args[0]?.toString() || "";
          if (
            message.includes("semver") ||
            message.includes("Invalid argument")
          ) {
            return; // Suppress semver errors
          }
          originalError.apply(console, args);
        };

        cc.run({
          // Configurazione generale
          guiOptions: {
            consentModal: {
              layout: "cloud",
              position: "bottom center",
              equalWeightButtons: true,
              flipButtons: false,
            },
            preferencesModal: {
              layout: "box",
              position: "right",
              equalWeightButtons: true,
              flipButtons: false,
            },
          },

          categories: {
            necessary: {
              enabled: true,
              readOnly: true,
            },
            analytics: {
              enabled: false,
              readOnly: false,
            },
          },

          language: {
            default: "it",
            translations: {
              it: {
                consentModal: {
                  title: "Utilizziamo i Cookie",
                  description:
                    'Questo sito utilizza cookie tecnici necessari per il corretto funzionamento e cookie analitici per migliorare l\'esperienza utente. Puoi personalizzare le tue preferenze cliccando su "Gestisci preferenze".',
                  acceptAllBtn: "Accetta tutti",
                  acceptNecessaryBtn: "Rifiuta",
                  showPreferencesBtn: "Gestisci preferenze",
                  footer: '<a href="/legal#cookie-policy">Privacy Policy</a>',
                },
                preferencesModal: {
                  title: "Impostazioni Cookie",
                  acceptAllBtn: "Accetta tutti",
                  acceptNecessaryBtn: "Rifiuta tutti",
                  savePreferencesBtn: "Salva impostazioni",
                  closeIconLabel: "Chiudi",
                  serviceCounterLabel: "Servizi",
                  sections: [
                    {
                      title: "Utilizzo dei Cookie",
                      description:
                        "Utilizziamo i cookie per garantire le funzionalità di base del sito web e per migliorare la tua esperienza online. Puoi scegliere per ogni categoria di accettare o rifiutare quando vuoi.",
                    },
                    {
                      title: "Cookie Strettamente Necessari",
                      description:
                        "Questi cookie sono essenziali per il corretto funzionamento del sito. Senza questi cookie, il sito non funzionerebbe correttamente.",
                      linkedCategory: "necessary",
                      cookieTable: {
                        headers: {
                          name: "Nome",
                          domain: "Dominio",
                          expiration: "Durata",
                          description: "Descrizione",
                        },
                        body: COOKIE_LIST.filter(
                          (c) => c.category === "necessary"
                        ).map((cookie) => ({
                          name: cookie.name,
                          domain: "cerebellum-hub.org",
                          expiration: cookie.duration,
                          description: cookie.description,
                        })),
                      },
                    },
                    {
                      title: "Cookie Analitici",
                      description:
                        "Questi cookie ci aiutano a capire come i visitatori interagiscono con il sito raccogliendo e riportando informazioni in modo anonimo.",
                      linkedCategory: "analytics",
                      cookieTable: {
                        headers: {
                          name: "Nome",
                          domain: "Dominio",
                          expiration: "Durata",
                          description: "Descrizione",
                        },
                        body: COOKIE_LIST.filter(
                          (c) => c.category === "analytics"
                        ).map((cookie) => ({
                          name: cookie.name,
                          domain: "cerebellum-hub.org",
                          expiration: cookie.duration,
                          description: cookie.description,
                        })),
                      },
                    },
                    {
                      title: "Maggiori informazioni",
                      description:
                        'Per qualsiasi domanda relativa alla nostra politica sui cookie e alle tue scelte, ti preghiamo di <a class="cc-link" href="/legal#cookie-policy">contattarci</a>.',
                    },
                  ],
                },
              },
            },
          },
        });

        // Restore original console.error
        setTimeout(() => {
          console.error = originalError;
        }, 100);

        console.log("🍪 CookieConsent: Inizializzazione completata");
      })
      .catch((error) => {
        console.error("❌ CookieConsent: Errore durante il caricamento", error);
      });
  }, []);

  return null;
};
